import { AlertLineReportDTO } from "../../models/alert-line-report/alert-line-report-dto";
import { STOModel } from "../../models/base/sto-model";
import { BaseApiService } from "../base";

export class AlertLineReportNoteFileDownloadApiService extends BaseApiService<AlertLineReportDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/SaveAlertLineReportNoteFileDownload",
    });
  }
}
